// extracted by mini-css-extract-plugin
module.exports = {"service-display":"service-display-3Hq3ZYE"};